import { render, staticRenderFns } from "./genre.vue?vue&type=template&id=46a02a72&scoped=true&"
import script from "./genre.vue?vue&type=script&lang=js&"
export * from "./genre.vue?vue&type=script&lang=js&"
import style0 from "./genre.vue?vue&type=style&index=0&id=46a02a72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a02a72",
  null
  
)

export default component.exports